import Logo from 'assets/images/logo-white.svg';
import useTranslation from 'hooks/useTranslation';
import { FaWhatsapp } from 'react-icons/fa';
import { MdOutlineEmail } from 'react-icons/md';

interface FooterProps {
  className?: string;
}

const Footer = ({ className }: FooterProps) => {
  const translation = useTranslation();

  return (
    <div className={className}>
      <div className="bg-background-blue px-4 pt-[60px] pb-10 lg:flex lg:flex-col lg:items-center lg:pb-20">
        <img
          alt="websnap"
          src={Logo}
          className="h-[36px] w-[161px] lg:h-[43px] lg:w-[190px]"
        />
        <p className="mt-5 text-sm text-secondary-grey lg:max-w-md lg:text-center">
          {translation.websnapSpecialize}
        </p>
        <p className="mt-3 text-sm text-secondary-grey">
          {translation.madeWithLove}
        </p>

        <div className="mt-10 flex items-center lg:mt-6">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-white">
            <FaWhatsapp className="h-5 w-5" />
          </div>
          <div className="ml-4 flex h-8 w-8 items-center justify-center rounded-full bg-white">
            <MdOutlineEmail className="h-5 w-5" />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center bg-background-footer py-5">
        <p className="text-xs text-secondary-grey">{translation.copyright}</p>
      </div>
    </div>
  );
};

export default Footer;
